import React, { Component } from "react";
import {
  fetchDashboardReport,
  fetchDashboardReportDL,
} from "../login/api.actions";
import { connect } from "react-redux";
import { Overlay, Reports } from "clorian-frontend-components";
import MultiselectTwoSides from "react-multiselect-two-sides";

const METABASE_ID = process.env.REACT_APP_METABASE_ID;
const METABASE_QUESTION_ID = process.env.REACT_APP_METABASE_QUESTION_ID;

class ReportsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardUrl: "",
      disabled: true,
      config: [],
      value: [],
      options: [],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { affiliateList } = this.props;

    if (affiliateList && affiliateList.length > 0) {
      const filteredAffiliateList = affiliateList.map(
        (affiliate) =>
          affiliate.affiliate.status === "enabled" && {
            name: affiliate.pointOfSaleId + " - " + affiliate["affiliate"].name,
            value: affiliate.pointOfSaleId,
          }
      );
      this.setState({ options: filteredAffiliateList });
      this.manageAffiliateList(affiliateList);
    }
  }

  manageAffiliateList(affiliateList) {
    let object = {};
    if (affiliateList) {
      affiliateList.forEach((affiliate, index) => {
        object[affiliate.pointOfSaleId] = false;
      });

      this.setState({
        affiliates: affiliateList,
        disabled: false,
        config: object,
      });

      this.createRequest(object);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.affiliateList &&
      this.props.affiliateList !== prevProps.affiliateList
    ) {
      this.manageAffiliateList(this.props.affiliateList);
    }
  }

  sendPetition(request) {
    const { dispatch } = this.props;

    dispatch(fetchDashboardReport(METABASE_ID, request)).then(
      ({ response }) => {
        this.setState({
          dashboardUrl: response && response.iframeUrl,
          disabled: false,
        });
      }
    );

    let metabaseQuestionIds = METABASE_QUESTION_ID.split(",");

    metabaseQuestionIds.forEach((metaId, index) => {
      dispatch(fetchDashboardReportDL(metaId, request)).then(({ response }) => {
        if (response && response.iframeUrl) {
          var key = "metaId" + metaId;
          var val = response.iframeUrl;
          var obj = {};
          obj[key] = val;

          this.setState(obj);
        }
      });
    });
  }

  createRequest(config) {
    let request = [{ name: "pos_id", value: [] }];

    Object.keys(config).forEach((id) => {
      if (config[id]) {
        request[0].value.push(id);
      }
    });
    this.setState({ pos_values: request[0].value.toString() });
    this.sendPetition(request);
  }

  handleInputChange(value) {
    let config = this.state.config;
    const data = {};
    Object.keys(config).map((key) => (data[key] = false));
    value && value.map((val) => (data[val] = true));
    let newConf = { ...config, ...data };
    this.setState({
      config: newConf,
      value: value,
    });

    this.createRequest(newConf);
  }

  shouldComponentUpdate(nextProps) {
    const { disabled, affiliates } = this.state;

    if (nextProps.affiliateList !== affiliates) {
      return true;
    }

    if (disabled || !("pos_values" in this.state)) {
      return false;
    }
    return true;
  }

  render() {
    const { dashboardUrl, disabled, value, options } = this.state;
    const selectedCount = value.length;
    const availableCount = options.length - selectedCount;

    return (
      <div className="container">
        <div className="mainBody">
          <MultiselectTwoSides
            {...this.state}
            className="msts_theme_example"
            onChange={this.handleInputChange}
            availableHeader="Available"
            availableFooter={`Available: ${availableCount}`}
            selectedHeader="Selected"
            selectedFooter={`Selected: ${selectedCount}`}
            placeholder="Search.."
            labelKey="name"
            showControls
            searchable
          />
        </div>

        <div className="reports">
          <Overlay loading={disabled} />
          <Reports dashboardUrl={dashboardUrl} height="1700px" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { affiliates } = state;

  return {
    affiliateList: affiliates.affiliatesList,
  };
};

export default connect(mapStateToProps)(ReportsContainer);
